import { FileData } from '@applyboard/school-applications-types-lib'
import { DocumentTags } from '../../../utils/enums'
import { additionalDocumentTypeOptions } from '../../../utils'

type FilesOfTypeOptions = {
  activeFiles?: boolean
}

export function getFilesOfType(
  fileTypes: DocumentTags[],
  fileData?: FileData,
  options?: FilesOfTypeOptions,
): FileData {
  return Object.entries(fileData || {}).reduce((acc, [id, fileData]) => {
    if (!fileData) return acc
    if (fileTypes.includes(fileData.type as unknown as DocumentTags)) {
      if (options?.activeFiles && !fileData.activeRecord) {
        return acc
      }
      acc[id] = fileData
    }
    return acc
  }, {} as FileData)
}

export function getFilesOfTypeLanguageProficiency(files?: FileData) {
  return getFilesOfType(
    [
      DocumentTags.LANGUAGE_TEST_IELTS,
      DocumentTags.LANGUAGE_TEST_TOEFL,
      DocumentTags.LANGUAGE_TEST_PTE,
      DocumentTags.LANGUAGE_TEST_CAEL,
      DocumentTags.LANGUAGE_TEST_MET,
      DocumentTags.LANGUAGE_TEST_CAMBRIDGE,
      DocumentTags.LANGUAGE_TEST_EPP,
      DocumentTags.LANGUAGE_TEST_OTHER,
      DocumentTags.LANGUAGE_TEST_DUOLINGO,
    ],
    files as FileData,
  )
}

export function getFilesOfTypeAdditionalDocuments(files?: FileData) {
  return getFilesOfType(
    Object.keys(additionalDocumentTypeOptions) as DocumentTags[],
    files as FileData,
  )
}
